module.exports = __webpack_public_path__ + "static/media/check_box_black21d3de8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/images/check_box_black.svg
// module id = 1403
// module chunks = 0